import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { CarBrakeHoldIcon } from '../../../../atoms/material-icons';
import { fetchAbsolutePath, fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import './shareholding.m.css';

const ShareHolding = () => {
  const [shareholdingComparisonData, setShareHoldingComparisonData] = useState({});
  const [shareholdingSnapshotData, setShareHoldingSnapshotData] = useState({});
  const graphLabelsArray = [];
  const graphValuesArray = [];
  const [initialLoading, setInitialLoading] = useState(true);
  const [currentPath, setCurrentPath] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const retrievedStockId = fetchStockId();
    const pagePath = fetchAbsolutePath();
    const getShareHoldingComparsionData = async () => {
      const response = await fetch(`/next/feapi/stock/shareholding-comparison/${retrievedStockId}`);
      const data = await response.json();
      setShareHoldingComparisonData(data?.data);
    };

    const getShareholdingSnapshotData = async () => {
      const response = await fetch(`/next/feapi/stock/shareholding-snapshot/${retrievedStockId}`);
      const data = await response.json();
      setShareHoldingSnapshotData(data?.data);
    };

    getShareHoldingComparsionData();
    getShareholdingSnapshotData();
    setCurrentPath(pagePath);
  }, []);

  shareholdingSnapshotData?.chart?.map((parameter) => {
    graphLabelsArray.push(parameter?.label);
  });

  shareholdingSnapshotData?.chart?.map((parameter) => {
    graphValuesArray.push(parameter?.value);
  });

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: false,
        text: '',
      },
      datalabels: {
        // eslint-disable-next-line no-unused-vars
        formatter: (val, context) => `${val}%`,
      },
      tooltip: {
        callbacks: {
          label: (ttItem) => `${ttItem.label}: ${ttItem.parsed}%`,
        },
      },
    },
  };

  const data = {
    labels: graphLabelsArray,
    datasets: [
      {
        label: '',
        data: graphValuesArray,

        backgroundColor: [
          '#0068D7',
          '#d01e51',
          '#14C588',
          '#2B2B2B',
          '#C7CDD1',
          '#5C6D77',
          '#ffffff',
        ],
        borderColor: ['#0068D7', '#d01e51', '#14C588', '#2B2B2B', '#C7CDD1', '#5C6D77', '#DADEE1'],
        borderWidth: 1,
      },
    ],
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="shareholding-container">
      <div styleName="header-title-container">
        <CarBrakeHoldIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">SHAREHOLDING</h2>
      </div>
      <div styleName="overall-container">
        {!shareholdingSnapshotData || isEmpty(shareholdingSnapshotData) ? (
          <div styleName="no-data-container-ext">
            <div styleName="no-data-container-int">
              <EmptyState subTextMessage={'for this stock at the moment'} />
            </div>
          </div>
        ) : (
          <div styleName="pie-text-container">
            <div styleName="chart-container">
              <Doughnut data={data} height="250px" width="250px" options={options} />
            </div>
            <div>
              <h4 styleName="snapshot-title">SNAPSHOT {shareholdingSnapshotData?.date}</h4>
              {shareholdingSnapshotData?.holdings?.map((holding, index) => (
                <div styleName="shareholding-data" key={index}>
                  <h6 styleName="holding-label">{holding.label}</h6>
                  <h4 styleName="holding-value">{holding.value}</h4>
                </div>
              ))}
            </div>
          </div>
        )}

        <div styleName="text-content-container">
          <h4 styleName="table-title">% Holdings ({moment().year()})</h4>
          {isEmpty(shareholdingComparisonData) || !shareholdingComparisonData ? (
            <div styleName="no-data-container-ext-holding">
              <div styleName="no-data-container-int">
                <EmptyState subTextMessage={'for this stock at the moment'} />
              </div>
            </div>
          ) : (
            <>
              <div styleName="shareholding-body">
                <table>
                  <tr>
                    <th>PEERS</th>
                    <th styleName="time-period">{shareholdingComparisonData?.quarters?.[0]}</th>
                    <th styleName="time-period">{shareholdingComparisonData?.quarters?.[1]}</th>
                    <th>CHANGE</th>
                  </tr>
                  {shareholdingComparisonData?.shareholding?.map((detail) => {
                    return (
                      <tr key={detail.text}>
                        <td styleName="detail-text">{detail?.text}</td>
                        <td>{detail?.quarter1}%</td>
                        <td>{detail?.quarter2}%</td>
                        <td
                          styleName={
                            detail?.chgp.toString().includes('-') ? 'negative' : 'positive'
                          }
                        >
                          {detail?.chgp}%
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShareHolding;
